import { frontendURL } from '../../../../helper/URLHelper';

const bulkMessage = accountId => ({
  parentNav: 'bulkMessage',           // nests under the "Campaigns" primary tab
  routes: ['bulkMessage_new', 'bulkMessage_history', 'bulkMessage_scheduled', 'bulkMessage_home'],          // must exactly match the route's `name`
  menuItems: [
    {
      icon: 'send',                 // pick any Chatwoot icon
      label: 'BULK_MESSAGE_NEW',     // Translation key
      key: 'bulkMessageNew',           // 🔑 required
      toState: frontendURL(
        `accounts/${accountId}/bulk_message/new`
      ),
      toStateName: 'bulkMessage_new',   // again, must match the route's name
    },
    {
      icon: 'document-list-clock',                 // Using different icon
      label: 'BULK_MESSAGE_HISTORY',     // Translation key
      key: 'bulkMessageHistory',           // 🔑 required
      toState: frontendURL(
        `accounts/${accountId}/bulk_message/history`
      ),
      toStateName: 'bulkMessage_history',   // again, must match the route's name
    },
    {
      icon: 'calendar-clock',
      label: 'BULK_MESSAGE_SCHEDULED',
      key: 'bulkMessageScheduled',
      toState: frontendURL(
        `accounts/${accountId}/bulk_message/scheduled`
      ),
      toStateName: 'bulkMessage_scheduled',
    },
  ],
});

export default bulkMessage;
